import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
  url: window.config.REACT_APP_KEYCLOAK_SERVER || "https://18.218.74.3:9443/",
  realm: window.config.REACT_APP_REALM || "Orchstro",
  clientId: window.config.REACT_APP_CLIENT || "Orchstro",
});

export default keycloak;
